export default __webpack_public_path__ + "static/media/HelveticaNowDisplay-Black.26350d11.ttf";